
export interface ISeascapeActivityLog {
    eventId: number | null;
    payload: string;
}


// Enums
export enum SeascapeActivityLogConstants {
    USER_LOGGED_IN = 1,
    PRODUCT_CHOOSE = 2,
     
    GREEN_CLICKED = 101,
    VALUE_CLICKED = 102,
    DCF_CLICKED = 103,
    ACTIVITY_CLICKED = 104,
    
    // 200 - 299 SEARCH Events
    SEARCHED_ENTERED = 200,//VESSEL MI OWNERSHIP MI SEKTOR MU JSONDA
    SECTOR_LEGEND_CLICKED = 201,
    MAP_VESSEL_CLICKED,


    // 300 - 399 FILTER        
    FILTER_APPLY = 300,// TEAM MI PERSONAL MI?
    FILTER_CREATE = 301,
    FILTER_UPDATE = 302,
    FILTER_DELETE = 303,
    FILTER_SEARCH = 304,//TEMA/PERSONAL

    // 300 - 399 PORTFOLIO
    PORTFOLIO_APPLY = 400,// TEAM MI PERSONAL MI?
    PORTFOLIO_CREATE = 401,
    PORTFOLIO_UPDATE = 402,
    PORTFOLIO_DELETE = 403,
    PORTFOLIO_UPLOAD_LIST = 404,
    PORTFOLIO_SEARCH = 405,//TEMA/PERSONAL

    MAP_LAYER_CHANGED = 500,
    MAP_MODE_CHANGED = 501,
}

